/**
 * Whether the project list can be trusted to be complete.
 *
 * The store starts at `environmentStateById: {}` and fills in as environments
 * connect, so "no projects" and "not asked yet" look identical from the list
 * alone. Anything that decides a project does not exist has to consult this
 * first — otherwise the first paint reads as "no such project" and the page
 * navigates away from a project that is about to appear.
 *
 * An environment that HAS reported and genuinely holds no projects counts as
 * hydrated: that is a real answer, and treating it as pending would hang the
 * page forever.
 */
export function isProjectListHydrated(
  environmentStateById: Readonly<Record<string, unknown>>,
): boolean {
  return Object.keys(environmentStateById).length > 0;
}
